import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { FullPageLoader } from "@/shared/components/Loading/Loading";
import { isValidInternalPath } from "../utils/navigation";

const PublicRoute = () => {
	const { isAuthenticated, isLoading } = useAuth();
	const location = useLocation();

	// Show loading while checking authentication status
	if (isLoading) {
		return <FullPageLoader />;
	}

	if (isAuthenticated) {
		// If there's a returnTo parameter, validate it to avoid open-redirects or loops.
		const params = new URLSearchParams(location.search);
		const returnTo = params.get("returnTo");

		// fallback to /campaigns if returnTo is invalid or an auth path
		const isAuthPath =
			returnTo === "/login" ||
			returnTo === "/register" ||
			returnTo === "/creator-register" ||
			returnTo === "/forgot-password";
		const safeReturnTo = isValidInternalPath(returnTo) && !isAuthPath ? returnTo : "/campaigns";

		return <Navigate to={safeReturnTo} replace />;
	}

	return <Outlet />;
};

export default PublicRoute;
